import apiClient from "../utils/apiClient";
import { PortalListCategoryDto } from "../types/PortalList";

export const getPortalListByCategoryDescription = async (
  categoryDescription: string,
): Promise<PortalListCategoryDto> => {
  const response = await apiClient.get<PortalListCategoryDto>(
    `/Portal/list-by-categoryDescription/${categoryDescription}`,
  );
  return response.data;
};
